<script setup>
import { onMounted, ref, computed } from 'vue'
import {Icon, Input, ProfilePicture, Textarea} from '@components'

import CenterLayout from './CenterLayout.vue'

import moment from 'moment'

// const questions = ref('Got it! Let’s find you a time slot! ')

const selectedSlot = ref(null)
const slots = computed(() => {
    const now = moment();
    const slots = [];
    
    for (let i = 0; i < 6; i++) {
        const nextSlot = now.clone().add(i * 30, 'minutes');
        // Only add slots that are in the future
        if (nextSlot.isAfter(now)) {
            slots.push(nextSlot.format('h:mm A'));
        }
    }
    
    return slots;
})

const timePeriod = (slot_start) => {
    const hour = moment(slot_start, 'h:mm A').hour()

    if (hour >= 6 && hour < 12) {
        return 'Morning'
    } else if (hour >= 12 && hour < 18) {
        return 'Afternoon'
    } else {
        return 'Evening'
    }
}

const timeIcon = ref({
    Morning: 'sunSetting02',
    Afternoon: 'sun',
    Evening: 'moonStar',
})

import { useChatCustomizer } from '@store/chatCustomizer';
const $chatCustomizer = useChatCustomizer();

import {useSettings} from '@store/settings';
const $settings = useSettings();

</script>

<template>
  <CenterLayout>
    <div class="h-[66px] w-[297px] rounded-md overflow-hidden m-auto mb-10">
      <img @click="$chatCustomizer.changeSecondaryMenu('date')" :src="Image('chat-customizer-top-banner.png')" class="opacity-30 cursor-pointer" alt="">
    </div>
    
    <div class="mb-10 text-center font-semibold text-lg">...</div>
    <div class="rounded-[14px] p-5 flex flex-col gap-5 bg-white w-[381px] m-auto">
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Questions</div>
        <Textarea v-model="$settings.settings.chat_widget.time.question"></Textarea>
      </div>
     
      <div class="flex gap-2 flex-wrap">
        <div v-for="slot in slots" :key="slot" @click="selectedSlot = slot" class="flex items-center gap-2 rounded-[58px] p-[10px_24px_10px_15px] cursor-pointer border border-[#D0D5DD]" :class="[selectedSlot == slot ? 'border-transparent bg-[#F2F4F7]' : 'border-[#D0D5DD]']">
            <Icon :name="timeIcon[timePeriod(slot)]" size="20px"/>
            <div class="text-[#101828] text-base font-medium">{{ slot }}</div>
        </div>
      </div>
    </div>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">Time</div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>Set your time slot</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>


<style>

</style>